'use client';

import { ProfileLayout } from '@up2stay/up2promo-api-client';
import { createContext, useContext } from 'react';

import type { PublicProfileLayout } from '../public-profile-layout';

const ProfileLayoutContext = createContext<PublicProfileLayout>(
  ProfileLayout.CARDS,
);

export function ProfileLayoutProvider({
  layout,
  children,
}: {
  layout: PublicProfileLayout;
  children: React.ReactNode;
}) {
  return (
    <ProfileLayoutContext.Provider value={layout}>
      {children}
    </ProfileLayoutContext.Provider>
  );
}

export function useProfileLayout(): PublicProfileLayout {
  return useContext(ProfileLayoutContext);
}
